export function formatNZD(amount) {
  if (amount === null || amount === undefined || amount === "") return "Price on request";
  const n = Number(amount);
  if (Number.isNaN(n) || n <= 0) return "Price on request";
  // Plain "$" style per founder decision #3 (board rev 11) — the "en-NZ"
  // currency style renders "NZ$" which we've locked out of the design system.
  const formatted = new Intl.NumberFormat("en-NZ", {
    maximumFractionDigits: n % 1 === 0 ? 0 : 2,
  }).format(n);
  return `$${formatted}`;
}

export function timeAgo(iso) {
  if (!iso) return "";
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "";
  const diff = Date.now() - then;
  const mins = Math.round(diff / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.round(hrs / 24);
  if (days < 30) return `${days}d ago`;
  const months = Math.round(days / 30);
  if (months < 12) return `${months}mo ago`;
  return `${Math.round(months / 12)}y ago`;
}

/** Return only digits from a phone string, for tel:/wa.me: links */
export function phoneDigits(str) {
  return String(str || "").replace(/[^0-9]/g, "");
}
